import React from "react";
import styled from "styled-components";

// HOC //
import withChat from "hoc/withChat";

// Stream Chat //
import { Chat, Channel, ChannelHeader, Thread, Window  } from "stream-chat-react";
import { MessageList, MessageInput, MessageInputFlat } from "stream-chat-react";
import "stream-chat-react/dist/css/index.css";

// Components //
import View from "components/View";
import WaitingScreen from './WaitingScreen';

const Root = styled(View)`
  width: 360px;
  height: 608px;
  border-radius: 4px;
  overflow: hidden;
  background-color: ${ ({ theme }) => theme.color.gray };
  box-shadow: 0 1px 5px 0 rgba(0,0,0,0.50), 0 2px 2px 0 rgba(0,0,0,0.43), 0 1px 40px 0 rgba(14,112,241,0.64);
`;

const ChatView = ({ channel, client, token, theme }) => {
  return (client && channel) ? (
    <Root>
      <Chat client={client} theme="messaging dark">
        <Channel channel={channel}>
          <Window hideOnThread>
            <ChannelHeader />
            <MessageList />
            <MessageInput Input={MessageInputFlat} />
          </Window>
          <Thread fullWidth />
        </Channel>
      </Chat>
    </Root>
  ) : (
    <Root>
      <WaitingScreen />
    </Root>
  );
};

export default withChat(ChatView);
